module.exports = __webpack_public_path__ + "static/img/share.bdf8398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/share.png
// module id = YJbS
// module chunks = 1